/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IoCloseSharp } from 'react-icons/io5';
import {
  resultCardId,
  hyphenate,
  workPackageStateCharacter
} from '../../utils/string';
import { openDetailCard } from '../../utils/sprintHelpers';
import { addWorkPackagesToTarget } from '../../actions/workPackageActions';
import { extractChildren } from '../../utils/hierarchyHelpers';

const WorkPackage = ({
  workPackage,
  unfinishedResults,
  isChecked,
  handleResultSelect,
  isChild,
  isNestedChild
}) => {
  let className;
  if (isChild && !isNestedChild) {
    className = 'indent-children';
  } else if (isNestedChild) {
    className = 'indent-children-nested';
  }
  let children = [];

  if (workPackage.level >= 2) {
    children = extractChildren(
      workPackage.id,
      unfinishedResults,
      workPackage.level
    );
  }

  return (
    <div>
      <div
        key={workPackage.id}
        className={`unfinished-results-list ${className}`}
      >
        <div className="ur-check-and-title">
          <div className="ur-label-checkbox">
            <label className="ur-checkbox-container">
              <input
                id={workPackage.id}
                type="checkbox"
                checked={isChecked(workPackage) > -1}
                onChange={() => handleResultSelect(workPackage.id)}
              />
              <span className="custom-checkmark" />
            </label>
            <a onClick={() => openDetailCard(workPackage)}>
              {workPackage.result_type
                ? resultCardId(workPackage)
                : `O${workPackage.id}`}
            </a>
          </div>
          <div className="feature-name" style={{ paddingLeft: '3px' }}>
            {workPackage.name}
          </div>
        </div>
        <div className="right ur-vrs-state">
          <span
            className={`icon ur-state ${hyphenate(workPackage.state || '')}`}
          >
            {workPackageStateCharacter(workPackage)}
          </span>
        </div>
      </div>
      {children.length > 0 &&
        children.map((child) => (
          <WorkPackage
            key={child.id}
            workPackage={child}
            unfinishedResults={unfinishedResults}
            isChecked={isChecked}
            handleResultSelect={handleResultSelect}
            isChild
            isNestedChild={isChild}
          />
        ))}
    </div>
  );
};

class UnfinishedChildren extends Component {
  state = {
    selectedIds: []
  };

  componentDidMount() {
    if (this.props.unfinishedResults.length > 0) {
      const selectedIds = this.props.unfinishedResults.map(
        (result) => result.id
      );
      this.setState({ selectedIds });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.targetId !== this.props.targetId ||
      nextProps.unfinishedResults !== this.props.unfinishedResults ||
      nextProps.parentWorkPackage !== this.props.parentWorkPackage
    ) {
      const selectedIds = nextProps.unfinishedResults.map(
        (result) => result.id
      );
      this.setState({ selectedIds });
    }
  }

  handleResultSelect = (resultId) => {
    const { selectedIds } = this.state;

    const resultIndex = selectedIds.findIndex((id) => id === resultId);

    if (resultIndex > -1) {
      const newUnfinishedResults = selectedIds.filter((id) => id !== resultId);
      this.setState({ selectedIds: newUnfinishedResults });
    } else {
      selectedIds.push(resultId);
      this.setState({ selectedIds });
    }
  };

  isChecked = (workPackage) =>
    this.state.selectedIds.findIndex((id) => id === workPackage.id);

  handleConfirmationClick = () => {
    const {
      isNewTarget,
      handleConfirmation,
      addWorkPackagesToTarget,
      targetId,
      parentWorkPackage,
      onClose
    } = this.props;
    const { selectedIds } = this.state;
    if (isNewTarget) {
      handleConfirmation([...selectedIds, parentWorkPackage.id]);
    } else {
      addWorkPackagesToTarget(parentWorkPackage.id, targetId, selectedIds);
    }
    onClose();
  };

  render() {
    const {
      isOpen,
      onClose,
      unfinishedResults,
      targetId,
      parentWorkPackage,
      target,
      isNewTarget
    } = this.props;
    const { selectedIds } = this.state;
    let topWorkPackages;

    topWorkPackages = unfinishedResults.filter((r) => {
      if (!unfinishedResults.find((wp) => wp.id === r.parent_id)) {
        return true;
      }
    });

    if (!isOpen) return null;

    return (
      <div
        className="detail-modal unfinished-children-modal"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="ur-modal-header">
              <div className="ur-modal-header-title">
                Select {resultCardId(parentWorkPackage)} children to move to{' '}
                {target.short_name}
              </div>
              <div>
                <button type="button" className="btn-close" onClick={onClose}>
                  <IoCloseSharp size="2em" />
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className="all-results">
                {topWorkPackages.map((workPackage) => (
                  <WorkPackage
                    key={workPackage.id}
                    workPackage={workPackage}
                    unfinishedResults={unfinishedResults}
                    isChecked={this.isChecked}
                    handleResultSelect={this.handleResultSelect}
                  />
                ))}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default ur-cancel"
                onClick={onClose}
              >
                CANCEL
              </button>
              <button
                type="button"
                className="btn btn-primary ur-continue"
                onClick={this.handleConfirmationClick}
              >
                CONTINUE
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      addWorkPackagesToTarget
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(UnfinishedChildren);
